import axios from 'axios';
import { instance } from '../network/ApiCall';

export async function fetchMessages() {
  const response = await instance.get('/admin/messages/get');
  // const data = await response.data;
  return response.data;
}
export async function insertMessages(data: any) {
  const response = await instance.post('/admin/messages/insert', data);
  // const data = await response.data;
  return response.data;
}
export async function updateMessages(data: any) {
  // console.log(data.data,data.id,"update msegshaje")
  const response = await instance.put(
    `/admin/messages/update/${data.id}`,
    data.data
  );
  // const data = await response.data;
  return response.data;
}
export async function GetDeleteMessages(id: any) {
  //console.log(data.data,data.id,"update msegshaje")
  const response = await instance.delete(`admin/messages/delete/${id}`);
  // const data = await response.data;
  return response.data;
}
